import { createApp } from 'vue'
import { getParam } from '~/js/helpers/url-helper'

const CLASS_NAME_TEIKIBIN_SELECT = 'js-teikibin-select'
const SELECTED_TYPE_PARAM = 'selected_type'

document.addEventListener('DOMContentLoaded', () => {
  const elementsTeikibinSelect = document.getElementsByClassName(
    CLASS_NAME_TEIKIBIN_SELECT
  )
  if (!elementsTeikibinSelect.length) return

  const setSelectedTypeParam = (type) => {
    if (!type) return
    const urlSearchParams = new URLSearchParams(location.search)
    urlSearchParams.set(SELECTED_TYPE_PARAM, type)
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`
    window.history.replaceState({}, '', newUrl)
  }
  const selectedTypeParam = getParam(SELECTED_TYPE_PARAM)

  Array.from(elementsTeikibinSelect).forEach((element) => {
    const elementsProductCard = document.getElementsByClassName(
      'js-teikibin-product-card'
    )
    const types = Array.from(elementsProductCard)
      .filter((element) => !element.attributes.disabled)
      .map((element) => {
        const { type, buyLink } = element.dataset
        return {
          type,
          buyLink,
        }
      })
    const selectedType =
      types.find((typeObj) => typeObj.type === selectedTypeParam) || types[0]
    setSelectedTypeParam(selectedType?.type)

    createApp({
      name: 'SectionsTeikibinSelect',
      data() {
        return { selectedType, isSelectPage: true }
      },
      methods: {
        isSelected(type) {
          return this.isSelectPage && this.selectedType?.type === type
        },
        goNext() {
          if (this.isSelectPage) {
            this.isSelectPage = false
            window.scrollTo({ top: 0, behavior: 'smooth' })
          } else window.location.href = this.selectedType.buyLink
        },
        setSelectedType(type) {
          this.selectedType = types.find((typeObj) => typeObj.type === type)
          setSelectedTypeParam(this.selectedType?.type)
        },
      },
    }).mount(element)
  })
})
